export const EXPERIMENTS_TEST_IDS = {
  page: 'experiments-hub-page',
  list: 'experiments-hub-list',
  emptyState: 'experiments-hub-empty',
  createButton: 'experiments-create-button',
  statusFilter: 'experiments-status-filter',
  card: (id: string) => `experiment-card-${id}`,
  cardState: (id: string) => `experiment-card-state-${id}`,
  cardType: (id: string) => `experiment-card-type-${id}`,
  actionRun: (id: string) => `experiment-action-run-${id}`,
  actionStop: (id: string) => `experiment-action-stop-${id}`,
  actionDeclareWinner: (id: string) => `experiment-action-declare-winner-${id}`,
  actionArchive: (id: string) => `experiment-action-archive-${id}`,
  actionEdit: (id: string) => `experiment-action-edit-${id}`,
  auditLog: (id: string) => `experiment-audit-log-${id}`,
  auditEntry: (id: string, index: number) => `experiment-audit-entry-${id}-${index}`,
  segmentResponseMap: (id: string) => `experiment-segment-response-${id}`,
  segmentResponseCell: (segment: string, variant: string) => `segment-response-cell-${segment}-${variant}`,
  // Spec E E2b — analyst review block on the card
  analystBlock: (id: string) => `experiment-analyst-block-${id}`,
  analystHeadline: (id: string) => `experiment-analyst-headline-${id}`,
  analystVitals: (id: string) => `experiment-analyst-vitals-${id}`,
  analystFinding: (id: string, index: number) => `experiment-analyst-finding-${id}-${index}`,
  analystAction: (id: string, index: number) => `experiment-analyst-action-${id}-${index}`,
  // D — campaign-brief block: verdict chips + Paid Acquisition deep link
  analystCampaign: (id: string) => `experiment-analyst-campaign-${id}`,
  analystCampaignVerdict: (id: string, campaignId: string) => `experiment-analyst-campaign-verdict-${id}-${campaignId}`,
  analystCampaignLink: (id: string) => `experiment-analyst-campaign-link-${id}`,
  // Spec E E3 — exposure-gate callout + actions-taken chips
  analystWGate: (id: string) => `experiment-analyst-wgate-${id}`,
  analystWGateAttempt: (id: string, index: number) => `experiment-analyst-wgate-attempt-${id}-${index}`,
  // W3 (J6) — "Manage autonomy" link on the wGate callout
  analystWGateManage: (id: string) => `experiment-analyst-wgate-manage-${id}`,
  analystActionsTaken: (id: string) => `experiment-analyst-actions-taken-${id}`,
  // FU part G (D-F4) — owner-facing manual research report generation
  generateResearchReport: 'experiments-generate-research-report',
  generateReportDialog: 'experiments-generate-report-dialog',
  generateReportPreset: (id: string) => `experiments-generate-report-preset-${id}`,
  generateReportConfirm: 'experiments-generate-report-confirm',
  generateReportError: 'experiments-generate-report-error',
  researchReportRefresh: (id: string) => `experiment-research-refresh-${id}`,
  researchGenerating: (id: string) => `experiment-research-generating-${id}`,
  // E2c Phase B — research report block + detail dialog
  researchBlock: (id: string) => `experiment-research-block-${id}`,
  researchHealth: (id: string) => `experiment-research-health-${id}`,
  researchAnomalies: (id: string) => `experiment-research-anomalies-${id}`,
  researchOpenReport: (id: string) => `experiment-research-open-${id}`,
  researchDialog: 'research-report-dialog',
  researchDialogLoading: 'research-report-dialog-loading',
  researchDialogError: 'research-report-dialog-error',
  researchDialogRetry: 'research-report-dialog-retry',
  researchSection: (sectionId: string) => `research-report-section-${sectionId}`,
  // E2c Phase C — expert panel (card line + dialog section)
  researchPanelLine: (id: string) => `experiment-research-panel-${id}`,
  researchPanelSection: 'research-report-panel-section',
  researchPanelPersona: (personaId: string) => `research-panel-persona-${personaId}`,
  // S6-I3 — product-owner Research Cycle launcher/progress/result.
  researchCycleOpen: (reportId: string) => `research-cycle-open-${reportId}`,
  researchCycleDialog: 'research-cycle-dialog',
  researchCycleLoading: 'research-cycle-loading',
  researchCyclePreflight: (reportId: string) => `research-cycle-preflight-${reportId}`,
  researchCycleStart: (reportId: string) => `research-cycle-start-${reportId}`,
  researchCycleStatus: (reportId: string) => `research-cycle-status-${reportId}`,
  researchCycleProgress: (reportId: string) => `research-cycle-progress-${reportId}`,
  researchCycleRetry: (reportId: string) => `research-cycle-retry-${reportId}`,
  researchCycleDone: (reportId: string) => `research-cycle-done-${reportId}`,
  researchCycleError: 'research-cycle-error',
  researchCycleResult: (reportId: string) => `research-cycle-result-${reportId}`,
  // Hypothesis form dialog
  formDialog: 'experiment-form-dialog',
  formName: 'experiment-form-name',
  formType: 'experiment-form-type',
  formStatement: 'experiment-form-statement',
  formPrimaryMetric: 'experiment-form-primary-metric',
  formExpectedEffect: 'experiment-form-expected-effect',
  // Spec D D1 — pre-registered minimum sample per variant (peeking rule)
  formMinimumSample: 'experiment-form-minimum-sample',
  formSuccessCriteria: 'experiment-form-success-criteria',
  formGuardrails: 'experiment-form-guardrails',
  formAbTestId: 'experiment-form-ab-test-id',
  // Free-text degradation of the A/B picker. Distinct id on purpose: the two
  // controls used to share formAbTestId, so a test clicking the "picker" would
  // silently land on the fallback text field and then time out hunting for an
  // option that never renders (dev regression 2026-07-29).
  formAbTestIdFallback: 'experiment-form-ab-test-id-fallback',
  formPlacementId: 'experiment-form-placement-id',
  formSegmentSplits: 'experiment-form-segment-splits',
  formSave: 'experiment-form-save',
  formError: 'experiment-form-error',
  formCreativeHandoffProtocol: 'experiment-form-creative-handoff-protocol',
  // Declare-winner dialog
  winnerDialog: 'experiment-winner-dialog',
  winnerVariantInput: 'experiment-winner-variant-input',
  winnerRationaleInput: 'experiment-winner-rationale-input',
  winnerConfirm: 'experiment-winner-confirm',
  // Pre-registration gate
  runBlockedHint: (id: string) => `experiment-run-blocked-${id}`,
  // Emulation run fields (type === 'emulation')
  cardRunStatus: (id: string) => `experiment-card-run-status-${id}`,
  cardRunTag: (id: string) => `experiment-card-run-tag-${id}`,
  emulationDetails: (id: string) => `experiment-emulation-details-${id}`,
  // Iteration A — decision surface (AC-801..806)
  cardSurfaceStatus: (id: string) => `experiment-card-surface-status-${id}`,
  // R3-2 — SRM badge in the card header (split-broken flag next to state chips)
  cardSrmBadge: (id: string) => `experiment-card-srm-${id}`,
  decisionSurface: (id: string) => `experiment-decision-surface-${id}`,
  decisionVerdict: (id: string) => `experiment-decision-verdict-${id}`,
  trustLine: (id: string) => `experiment-trust-line-${id}`,
  evidenceBlock: (id: string) => `experiment-evidence-block-${id}`,
  proposalsFeed: (id: string) => `experiment-proposals-feed-${id}`,
  proposalItem: (id: string, index: number) => `experiment-proposal-item-${id}-${index}`,
  openReportScope: (id: string) => `experiment-open-report-scope-${id}`,
  // U7 — review state on the feed (AC-1008)
  reviewSummary: (id: string) => `experiment-review-summary-${id}`,
  // Iteration D — interpretation layer (AC-1102/1103/1106)
  interpretationHeadline: (id: string) => `experiment-interpretation-headline-${id}`,
  interpretationBlock: (id: string) => `experiment-interpretation-block-${id}`,
  actionItem: (id: string, index: number) => `experiment-action-item-${id}-${index}`,
  actionItemLink: (id: string, index: number) => `experiment-action-item-link-${id}-${index}`,
  // Spec C (C1) — kind-aware action affordances (AC-C1-1..4)
  actionItemDeclareWinner: (id: string, index: number) => `experiment-action-item-declare-winner-${id}-${index}`,
  actionItemRollout: (id: string, index: number) => `experiment-action-item-rollout-${id}-${index}`,
  actionItemFork: (id: string, index: number) => `experiment-action-item-fork-${id}-${index}`,
  actionItemAudiences: (id: string, index: number) => `experiment-action-item-audiences-${id}-${index}`,
  // Spec D4 — candidate conveyor block (AC-D4-4/5/10)
  candidateBlock: (id: string) => `experiment-candidate-block-${id}`,
  candidatePrepare: (id: string) => `experiment-candidate-prepare-${id}`,
  candidateStep: (id: string, index: number) => `experiment-candidate-step-${id}-${index}`,
  candidatePolish: (id: string) => `experiment-candidate-polish-${id}`,
  candidateViewDiff: (id: string) => `experiment-candidate-view-diff-${id}`,
  candidateRunAb: (id: string) => `experiment-candidate-run-ab-${id}`,
  candidatePublish: (id: string) => `experiment-candidate-publish-${id}`,
  candidateDiscard: (id: string) => `experiment-candidate-discard-${id}`,
  candidateRebuild: (id: string) => `experiment-candidate-rebuild-${id}`,
  candidateRetry: (id: string) => `experiment-candidate-retry-${id}`,
  candidateStaleChip: (id: string) => `experiment-candidate-stale-chip-${id}`,
  candidateConfirmDialog: 'experiment-candidate-confirm-dialog',
  candidateConfirmAccept: 'experiment-candidate-confirm-accept',
  // J1 — advisory MDE/feasibility planner inside the hypothesis form.
  formMde: 'experiment-form-mde',
  feasibilityPanel: 'experiment-form-feasibility-panel',
  feasibilityStatus: 'experiment-form-feasibility-status',
  feasibilityTechDetails: 'experiment-form-feasibility-tech-details',
  feasibilityHorizon: (weeks: number) => `experiment-form-feasibility-horizon-${weeks}w`,
  feasibilityRecommendation: 'experiment-form-feasibility-recommendation',
  feasibilityUseMde: 'experiment-form-feasibility-use-mde',
  // S8 — lazy, read-only advanced readiness panel.
  advancedReadinessPanel: (id: string) => `experiment-advanced-readiness-${id}`,
  advancedReadinessSummary: (id: string) => `experiment-advanced-readiness-summary-${id}`,
  advancedReadinessStatus: (id: string) => `experiment-advanced-readiness-status-${id}`,
  advancedReadinessBody: (id: string) => `experiment-advanced-readiness-body-${id}`,
  advancedReadinessProgress: (id: string) => `experiment-advanced-readiness-progress-${id}`,
  advancedReadinessBlockers: (id: string) => `experiment-advanced-readiness-blockers-${id}`,
  advancedReadinessBlocker: (id: string, index: number) => `experiment-advanced-readiness-blocker-${id}-${index}`,
  advancedReadinessRetry: (id: string) => `experiment-advanced-readiness-retry-${id}`,
  // J2-I1 — one-click winner rollout dialog (gates rendered verbatim from server vetoes)
  rolloutDialog: 'experiment-rollout-dialog',
  rolloutGate: (gate: string) => `experiment-rollout-gate-${gate}`,
  rolloutConfirm: 'experiment-rollout-confirm',
  rolloutCancel: 'experiment-rollout-cancel',
  rolloutResult: 'experiment-rollout-result',
  rolloutProbe: 'experiment-rollout-probe',
  rolloutRollback: 'experiment-rollout-rollback',
  rolloutVetoBanner: 'experiment-rollout-veto-banner',
  // Pricing planner (plan 2026-08-10 Increment 3, AC-001..017) — hub Pricing tab.
  hubTabs: 'experiments-hub-tabs',
  hubTabExperiments: 'experiments-hub-tab-experiments',
  hubTabPricing: 'experiments-hub-tab-pricing',
  pricingSection: 'pricing-planner-section',
  pricingBasisChip: 'pricing-basis-chip',
  pricingList: 'pricing-experiments-list',
  pricingEmptyState: 'pricing-empty-state',
  pricingColdStart: 'pricing-cold-start-checklist',
  pricingColdStartStep: (step: number) => `pricing-cold-start-step-${step}`,
  pricingMonitoringPanel: (id: string) => `pricing-monitoring-panel-${id}`,
  pricingGuardrailRow: (id: string, guardrail: string) => `pricing-guardrail-${id}-${guardrail}`,
  // Pricing loop v2 Phase 4 (AC-091/095; approved round-4 mocks) — monitoring lock + hint cards.
  pricingMonitoringLock: (id: string) => `pricing-monitoring-lock-${id}`,
  pricingHintsSection: 'pricing-hints-section',
  pricingHintCard: (slug: string) => `pricing-hint-${slug}`,
  pricingHintRegister: (slug: string) => `pricing-hint-register-${slug}`,
  pricingHintDismiss: (slug: string) => `pricing-hint-dismiss-${slug}`,
  pricingHintDismissedLine: (slug: string) => `pricing-hint-dismissed-${slug}`,
  pricingHintRestore: (slug: string) => `pricing-hint-restore-${slug}`,
  pricingHintsSilent: 'pricing-hints-silent',
  pricingDismissDialog: 'pricing-dismiss-dialog',
  pricingDismissReason: (key: string) => `pricing-dismiss-reason-${key}`,
  pricingDismissConfirm: 'pricing-dismiss-confirm',
  // Pricing loop v2 Phase 3a (plan §6 7a a–f + 7b; AC-076..079) — prefilled register confirm.
  pricingConfirmDialog: 'pricing-confirm-dialog',
  pricingConfirmOfferRow: (rowKey: string) => `pricing-confirm-offer-${rowKey}`,
  pricingConfirmOfferPicker: (rowKey: string) => `pricing-confirm-offer-picker-${rowKey}`,
  pricingConfirmScreens: 'pricing-confirm-screens',
  pricingConfirmGuardrail: (guardrail: string) => `pricing-confirm-guardrail-${guardrail}`,
  pricingConfirmAxisPicker: 'pricing-confirm-axis-picker',
  pricingManualDraftButton: 'pricing-manual-draft-button',
  pricingConfirmRegister: 'pricing-confirm-register',
  pricingConfirmBlocked: 'pricing-confirm-blocked',
  // Pricing loop v2 Phase 2 remainder (plan §2/§3; AC-060/064/068) — cells + candidates + history.
  pricingRecsSection: 'pricing-recs-section',
  pricingRecsCellsTable: 'pricing-recs-cells-table',
  pricingRecsCellRow: (key: string) => `pricing-recs-cell-${key}`,
  pricingRecsZoneChip: (key: string) => `pricing-recs-zone-${key}`,
  pricingRecsRemainderRow: 'pricing-recs-remainder-row',
  pricingRecsActBanner: (key: string) => `pricing-recs-act-${key}`,
  pricingRecsCandidate: (id: string) => `pricing-recs-candidate-${id}`,
  pricingRecsCandidateRegister: (id: string) => `pricing-recs-candidate-register-${id}`,
  pricingRecsSuppressed: (id: string) => `pricing-recs-suppressed-${id}`,
  pricingRecsDraftRegistered: (id: string) => `pricing-recs-draft-registered-${id}`,
  pricingRecsHistoryToggle: 'pricing-recs-history-toggle',
  pricingRecsHistoryView: 'pricing-recs-history-view',
  pricingRecsHistoryBack: 'pricing-recs-history-back',
  pricingRecsHistoryTable: 'pricing-recs-history-table',
  pricingRecsHistoryRow: (id: string) => `pricing-recs-history-${id}`,
  pricingRecsHistoryEmpty: 'pricing-recs-history-empty',
  pricingRecsEmpty: 'pricing-recs-empty',
  /* Phase 1 — per-lane readiness + «pull served» (AC-013/014). These six are the
     ONLY `pricingCalc*` keys left: the calculator they belonged to was replaced by
     the unit-economics port (`pricingUe*`, 2026-09-19) and its 28 keys were deleted
     with the last spec rows that read them; the served panel above the ported
     surface, and its status alert, are still rendered and still theirs. */
  pricingCalcServedPanel: 'pricing-calc-served-panel',
  pricingCalcReadiness: 'pricing-calc-readiness',
  pricingCalcFunnelSelect: 'pricing-calc-funnel-select',
  pricingCalcPullServed: 'pricing-calc-pull-served',
  pricingCalcLaneChip: (lane: string) => `pricing-calc-lane-${lane}`,
  pricingCalcServedNotes: 'pricing-calc-served-notes',
  // Phase 5 (AC-030/031): M0 template gallery + measurement plan (cold start)
  pricingGallery: 'pricing-gallery',
  pricingGalleryCategory: 'pricing-gallery-category',
  pricingGalleryAnchor: 'pricing-gallery-anchor',
  pricingGalleryTraffic: 'pricing-gallery-traffic',
  pricingGalleryCard: (id: string) => `pricing-gallery-card-${id}`,
  pricingGalleryPick: (id: string) => `pricing-gallery-pick-${id}`,
  /** ONE prior-based chip for the whole ranking (review A-F15): id = 'all'. */
  pricingGalleryChip: (id: string) => `pricing-gallery-chip-${id}`,
  /** Card title carrying the benchmark-book entries tooltip. */
  pricingGalleryCardTitle: (id: string) => `pricing-gallery-card-title-${id}`,
  pricingGalleryOverlap: 'pricing-gallery-overlap',
  pricingGalleryPlan: 'pricing-gallery-plan',
  pricingGalleryPlanRow: (key: string) => `pricing-gallery-plan-${key}`,
  pricingGalleryCreate: 'pricing-gallery-create',
  pricingGalleryCreateNote: 'pricing-gallery-create-note',
  // P6 create-at-the-end (AC-032.1..10) — «Proposed testids» in the acceptance
  // file (spec authority) named these `pricing-gallery-create-dialog...`;
  // that naming wins over any earlier draft.
  pricingGalleryCreateDialog: 'pricing-gallery-create-dialog',
  pricingGalleryCreateDialogRow: (id: string) => `pricing-gallery-create-dialog-row-${id}`,
  pricingGalleryCreateDialogRowCheckbox: (id: string) => `pricing-gallery-create-dialog-row-checkbox-${id}`,
  pricingGalleryCreateDialogConfirm: 'pricing-gallery-create-dialog-confirm',
  pricingGalleryCreateDialogClose: 'pricing-gallery-create-dialog-close',
  pricingGalleryCreateDialogStripeLink: 'pricing-gallery-create-dialog-stripe-link',
  pricingGalleryCreateDialogResult: (id: string) => `pricing-gallery-create-dialog-result-${id}`,
  pricingGalleryCreateDialogRetry: 'pricing-gallery-create-dialog-retry',
  // P7 live mode (AC-104): the Stripe test/live control, the real-money
  // acknowledgement, the error-toned live primary and the CLI-manifest export.
  pricingGalleryCreateDialogMode: 'pricing-gallery-create-dialog-mode',
  pricingGalleryCreateDialogModeTest: 'pricing-gallery-create-dialog-mode-test',
  pricingGalleryCreateDialogModeLive: 'pricing-gallery-create-dialog-mode-live',
  pricingGalleryCreateDialogLiveAck: 'pricing-gallery-create-dialog-live-ack',
  pricingGalleryCreateDialogConfirmLive: 'pricing-gallery-create-dialog-confirm-live',
  pricingGalleryCreateDialogCopyManifest: 'pricing-gallery-create-dialog-copy-manifest',
  pricingGalleryCreateDialogStripeLiveLink: 'pricing-gallery-create-dialog-stripe-live-link',
  /** P7 tier-3 fix (P1-3): inline copy-manifest confirmation in the actions
   * row — replaces the portal Snackbar that covered the button and lived
   * outside the aria-modal dialog. */
  pricingGalleryCreateDialogCopyNotice: 'pricing-gallery-create-dialog-copy-notice',
  /** P6 (AC-032.4): the success trace after the dialog closes. */
  pricingGalleryCreateSnackbar: 'pricing-gallery-create-snackbar',
  /* -------------------------------------------------------------------------
   * Unit-economics admin port (2026-09-19) — the public calculator's sections
   * ported onto the Pricing tab. `pricingUe*` is the prefix of the whole ported
   * surface; the `pricingCalc*` keys of the section it replaced were DELETED
   * with the last spec rows that read them (2026-09-19, task 7) — only the
   * served panel's own six survive, because that panel is still rendered.
   * ---------------------------------------------------------------------- */
  pricingUeSection: 'pricing-ue-section',
  /** The registry palette could not be read — a NAMED state, never a blank (UEA-AC-050). */
  pricingUePaletteError: 'pricing-ue-palette-error',
  pricingUeChainCard: (key: string) => `pricing-ue-chain-${key}`,
  pricingUeChainSlider: (key: string) => `pricing-ue-chain-slider-${key}`,
  pricingUeChainPeople: (key: string) => `pricing-ue-chain-people-${key}`,
  /** What one person at the step costs — `$5.00 each` — beside the figure (p1/p2/p3/buys; owner, 2026-09-22). */
  pricingUeChainStepCost: (key: string) => `pricing-ue-chain-step-cost-${key}`,
  pricingUeChainBe: (key: string) => `pricing-ue-chain-be-${key}`,
  pricingUeBuysCard: 'pricing-ue-buys-card',
  pricingUeVolumeAmount: 'pricing-ue-volume-amount',
  pricingUeVolumeUnit: 'pricing-ue-volume-unit',
  /** The readiness line under the volume tile (Task 12, RD1, 2026-09-21). */
  pricingUeReadiness: 'pricing-ue-readiness',
  pricingUeKpi: (key: string) => `pricing-ue-kpi-${key}`,
  pricingUeMixTile: 'pricing-ue-mix-tile',
  pricingUeBasisFirst: 'pricing-ue-basis-first',
  pricingUeBasisLtv: 'pricing-ue-basis-ltv',
  pricingUeReset: 'pricing-ue-reset',
  pricingUeQuote: 'pricing-ue-quote',
  pricingUeQuoteCell: (key: string) => `pricing-ue-quote-${key}`,
  /* Advanced fold (2026-09-21) — what does not reach the account. Sliders are
     `UeRange` (the id sits on the Slider ROOT; drive `input[type=range]` inside
     it by keyboard). The two pickers are MUI Selects: the id sits on the native
     input, the listbox opens from the `[role="combobox"]` beside it. */
  pricingUeAdvancedFold: 'pricing-ue-advanced-fold',
  pricingUeDeductionClear: (kind: string) => `pricing-ue-deduction-clear-${kind}`,
  pricingUeFeePreset: 'pricing-ue-fee-preset',
  pricingUeAdvancedRefusal: 'pricing-ue-advanced-refusal',
  pricingUeFeePct: 'pricing-ue-fee-pct',
  pricingUeFeeFixed: 'pricing-ue-fee-fixed',
  pricingUeFeePerCharge: (id: string) => `pricing-ue-fee-per-charge-${id}`,
  /* Provider-fee scheme (2026-09-22 plan, Task 7) — D6.1/D-10, mirrors the
     site's `ueFeeScheme` / `ueFeePricesDate`. `pricingUeFeeScheme` renders only
     while a PROVIDER fee is stated (`null` with a custom fee alone, UE-AC-110);
     `pricingUeFeePricesDate` is present under the preset picker in EVERY fee
     state, including "Not counted". */
  pricingUeFeeScheme: 'pricing-ue-fee-scheme',
  pricingUeFeePricesDate: 'pricing-ue-fee-prices-date',
  /* «Your own fees» (Task 8b, 2026-09-21) — user-named fees beside the
     provider preset. `pricingUeAddFee` exists only under `MAX_CUSTOM_FEES`;
     the name is a `StyledTextField` (id on the ROOT — drive `.locator('input')`). */
  pricingUeAddFee: 'pricing-ue-add-fee',
  pricingUeCustomFee: (id: string) => `pricing-ue-custom-fee-${id}`,
  pricingUeCustomFeeName: (id: string) => `pricing-ue-custom-fee-name-${id}`,
  pricingUeCustomFeePct: (id: string) => `pricing-ue-custom-fee-pct-${id}`,
  pricingUeCustomFeeFixed: (id: string) => `pricing-ue-custom-fee-fixed-${id}`,
  pricingUeCustomFeeRemove: (id: string) => `pricing-ue-custom-fee-remove-${id}`,
  pricingUeTaxMode: 'pricing-ue-tax-mode',
  pricingUeTaxRate: 'pricing-ue-tax-rate',
  pricingUeTaxRead: 'pricing-ue-tax-read',
  pricingUeRefunds: 'pricing-ue-refunds',
  pricingUeRefundsPointer: 'pricing-ue-refunds-pointer',
  /* D6.4 (2026-09-22 plan, Task 7) — under `onRefund: 'returned'` (a store
     scheme), independent of whether a refund rate is itself stated. */
  pricingUeRefundsReturned: 'pricing-ue-refunds-returned',
  pricingUeRefundsOn: (id: string) => `pricing-ue-refunds-on-${id}`,
  pricingUeRefundsKnob: (id: string) => `pricing-ue-refunds-knob-${id}`,
  pricingUeRefundsRead: (id: string) => `pricing-ue-refunds-read-${id}`,
  pricingUeRefundsAction: (id: string) => `pricing-ue-refunds-action-${id}`,
  /** The row's own ClaimChip (UEA-AC-059, Task 15) — "yours" / "from Advanced" / seeded observed. */
  pricingUeRefundsChip: (id: string) => `pricing-ue-refunds-chip-${id}`,
  pricingUeDisputesShare: 'pricing-ue-disputes-share',
  pricingUeDisputeFee: 'pricing-ue-dispute-fee',
  /* D6.2 (2026-09-22 plan, Task 7) — the knob's row slot under a store scheme
     (`onDispute: 'refund'`): the knob is never drawn `disabled` (UX-5); this
     note fills the SAME reserved-height slot instead. */
  pricingUeDisputeFeeNote: 'pricing-ue-dispute-fee-note',
  pricingUeExposure: 'pricing-ue-exposure',
  /* D6.3 — the exposure slot's store line, same reserved-height idiom. */
  pricingUeExposureStore: 'pricing-ue-exposure-store',
  /* Activation — «opened the app after paying» (Task 14, 2026-09-21). */
  pricingUeActivationShare: 'pricing-ue-activation-share',
  pricingUeActivationChecks: 'pricing-ue-activation-checks',
  pricingUeWaterfall: 'pricing-ue-waterfall',
  pricingUeWaterfallRow: (key: string) => `pricing-ue-waterfall-row-${key}`,
  /* Payback month, on the net basis (Task 10, 2026-09-21) — the last line of
     the fold, at the end of the `AccordionDetails`. */
  pricingUePayback: 'pricing-ue-payback',
  pricingUeCostPerBuyer: 'pricing-ue-cost-per-buyer',
  /* -------------------------------------------------------------------------
   * Section 3 — the registry products, their shares and the two create doors.
   * One key per element per instance: a product is either on the paywall (a
   * card) or kept aside (a row), so `pricingUeDanger` never collides.
   * ---------------------------------------------------------------------- */
  pricingUeProductCard: (id: string) => `pricing-ue-product-${id}`,
  pricingUeExpand: (id: string) => `pricing-ue-expand-${id}`,
  /** CAD-1 (ruling R-23, UEA-AC-063) — the row's own warn line, on the card's
      HEAD stack, visible with the disclosure CLOSED. Same condition as
      `pricingUeChecksNoPrior` below: no book prior, knob still at one. */
  pricingUeRowNoPrior: (id: string) => `pricing-ue-row-no-prior-${id}`,
  pricingUeShare: (id: string) => `pricing-ue-share-${id}`,
  pricingUeChecks: (id: string) => `pricing-ue-checks-${id}`,
  /** The sentence the charges knob prints INSTEAD of a slider it cannot offer. */
  pricingUeChecksFixed: (id: string) => `pricing-ue-checks-fixed-${id}`,
  /** CAD-1 (ruling R-23, UEA-AC-063) — the SAME warning as the row's, worded
      for the opened card: no book prior for this cadence, and the charges
      knob still reads the invented floor of one payment. */
  pricingUeChecksNoPrior: (id: string) => `pricing-ue-checks-no-prior-${id}`,
  pricingUeClose: (id: string) => `pricing-ue-close-${id}`,
  pricingUeTrialConv: (id: string) => `pricing-ue-trial-conv-${id}`,
  pricingUeMechanicsFold: 'pricing-ue-mechanics-fold',
  pricingUeMechGate: (kind: string) => `pricing-ue-mech-gate-${kind}`,
  pricingUeMechEnable: (id: string, kind: string) => `pricing-ue-mech-enable-${id}-${kind}`,
  pricingUeMechTarget: (id: string, kind: string) => `pricing-ue-mech-target-${id}-${kind}`,
  pricingUeMechConv: (id: string, kind: string) => `pricing-ue-mech-conv-${id}-${kind}`,
  /**
   * The switch that flips a GATE from inside a product's card.
   *
   * Rendered only while that gate is off and the mechanic has an audience —
   * the state in which every other control of the row is disabled. The public
   * page's `ueMechanicTurnOn`, same two arguments.
   */
  pricingUeMechTurnOn: (id: string, kind: string) => `pricing-ue-mech-turn-on-${id}-${kind}`,
  /**
   * MECH-1 (ruling R-22, UEA-AC-064) — one toggle button per upsell kind
   * (`addon` / `upgrade`) on a product's upsell row, only while that upsell
   * runs. The public page's `ueUpsellKind`, same two arguments.
   */
  pricingUeUpsellKind: (id: string, kind: string) => `pricing-ue-upsell-kind-${id}-${kind}`,
  pricingUeAsideRow: (id: string) => `pricing-ue-aside-${id}`,
  /** The danger control and the named action inside its confirmation popover. */
  pricingUeDanger: (id: string) => `pricing-ue-danger-${id}`,
  pricingUeDangerConfirm: (id: string) => `pricing-ue-danger-confirm-${id}`,
  pricingUeAddOpen: 'pricing-ue-add-open',
  pricingUeAddPick: 'pricing-ue-add-pick',
  pricingUeAddWhere: 'pricing-ue-add-where',
  pricingUeAddConfirm: 'pricing-ue-add-confirm',
  /** «Create a new product…» — the real Products dialog, in the panel and in the empty state. */
  pricingUeAddCreate: 'pricing-ue-add-create',
  /** A product the money facts observed that the registry does not carry (UEA-AC-012). */
  pricingUeServedRow: (id: string) => `pricing-ue-served-row-${id}`,
  /** Registered products with no readable USD price — listed, never dropped. */
  pricingUeUnavailableList: 'pricing-ue-unavailable-list',
  /** The empty registry: the preset menus (D2b). */
  pricingUeEmpty: 'pricing-ue-empty',
  pricingUePreset: (id: string) => `pricing-ue-preset-${id}`,
  pricingUePresetCreate: (id: string) => `pricing-ue-preset-create-${id}`,
  /* -------------------------------------------------------------------------
   * Section 4 — the scenario as a value: its name, this tab's link, the
   * document in and out, and the door to the public calculator (D2).
   * ---------------------------------------------------------------------- */
  /** The scenario name — one of rule 0's named free-text fields (UEA-AC-038). */
  pricingUeLabel: 'pricing-ue-label',
  /** "Measured on" (Task 13, M1, 2026-09-21) — directly under the name row; the same rule-0 exception. */
  pricingUeMeasured: 'pricing-ue-measured',
  /** The read-only link box: what «Copy link» copies, and what a reader can select by hand. */
  pricingUeLinkBox: 'pricing-ue-link-box',
  pricingUeCopyLink: 'pricing-ue-copy-link',
  pricingUeCopyJson: 'pricing-ue-copy-json',
  pricingUeDownload: 'pricing-ue-download',
  /** The import button, and the hidden file input it opens (what a spec sets files on). */
  pricingUeImport: 'pricing-ue-import',
  pricingUeImportFile: 'pricing-ue-import-file',
  /** One live region for everything section 4 has to answer, refusals included. */
  pricingUeShareStatus: 'pricing-ue-share-status',
  /** «Open on the site ↗» — the public calculator, same scenario, typed products (UEA-AC-054). */
  pricingUeOpenOnSite: 'pricing-ue-open-on-site',
} as const;
